import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServiciosPage from './pages/ServiciosPage';
import RecursosPage from './pages/RecursosPage';
import ContactoPage from './pages/ContactoPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Update page title based on current route
  useEffect(() => {
    const pageTitles: Record<string, string> = {
      '/': 'Perspectiva Data | Estrategia de Datos para Empresas Mexicanas',
      '/servicios': 'Servicios de Estrategia de Datos | Perspectiva Data',
      '/recursos': 'Recursos y Conocimiento | Perspectiva Data',
      '/contacto': 'Contacto | Perspectiva Data'
    };
    
    document.title = pageTitles[location.pathname] || 'Perspectiva Data';
    
    // Update meta description based on route
    const metaDescriptions: Record<string, string> = {
      '/': 'Convertimos inversiones en datos en resultados de negocio tangibles para empresas mexicanas. Estrategia, implementación y optimización de datos.',
      '/servicios': 'Soluciones de datos diseñadas para generar valor de negocio real y medible para empresas mexicanas. Evaluación estratégica, implementación y más.',
      '/recursos': 'Artículos, podcasts y herramientas para potenciar tu estrategia de datos. Recursos gratuitos para empresas mexicanas.',
      '/contacto': 'Contáctanos para transformar tus datos en resultados de negocio tangibles. Agenda una sesión de diagnóstico gratuita.'
    };
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaDescriptions[location.pathname] || metaDescriptions['/']);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/recursos" element={<RecursosPage />} />
        <Route path="/contacto" element={<ContactoPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;